export default "__VITE_ASSET__DQ3TilQm__"